// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--qnvX0";
export var btnBlock = "banner-module--btnBlock--pybzu";
export var container = "banner-module--container--zONN4";
export var hideMobBlock = "banner-module--hideMobBlock--h7JJA";
export var img = "banner-module--img--JPLP4";
export var indexPkw = "banner-module--indexPkw--sa3wx";
export var mobBtn = "banner-module--mobBtn--mFq3L";
export var secondContainer = "banner-module--secondContainer--JjcGj";
export var section = "banner-module--section--t3qPZ";
export var text = "banner-module--text--ehAJw";